/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */

export default function deleteSearchParamByKeyValue(searchParams, key, value) {
    const allKeys = [];
    const entriesToKeep = [];

    for (const [k, v] of searchParams.entries()) {
        if (k === undefined || v === undefined) continue;
        allKeys.push(k);
        if (k === key && v === value) continue;
        entriesToKeep.push([k, v]);
    }

    for (const k of allKeys) {
        searchParams.delete(k);
    }

    for (const [k, v] of entriesToKeep) {
        searchParams.append(k, v);
    }
}
